import React, { useEffect, useState } from 'react'
import Popup from '../../../../../../layouts/Popup'
import { Container, Grid } from '@mui/material'
import Controls from '../../../../../../components/Entry/Controls'
import DataSetsService from '../../../../../datasets/services/DataSets'

function AddTransect(props) {
    const { openPopup, setOpenPopup, onSave, dataVegetation = {}, values, setValues } = props

    const [data, setData] = useState({})
    const [transectTypeOptions, setTransectTypeOptions] = useState([])
    const dataset = DataSetsService.load()

    const handleSaveData = () => {
        onSave({ values: [...dataVegetation.values, data], moyenne: 0 })
        setValues({ ...values, transect: [...dataVegetation.values, data] })
        setOpenPopup(false)
    }

    useEffect(() => {
        dataset
            .getDataCode('transect_type')
            .then((response) => {
                if (response?.data) {
                    const dataArray = JSON.parse(response.data[0].database)
                    setTransectTypeOptions(dataArray)
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error)
            })
    }, [])
    return (
        <>
            <Popup title={'Transect'} sx={{ width: '400px' }} setOpenPopup={setOpenPopup} openPopup={openPopup}>
                <Grid container>
                    <Container>
                        <Controls.AutoCompleteSelect
                            label="Nom"
                            name="name"
                            value={data?.name || ''}
                            options={transectTypeOptions || []}
                            onChange={(e) => {
                                setData({ ...data, name: e.target.value })
                            }}
                            labelKey="label"
                            valueKey="label"
                        />
                        {/* <Controls.Input
                            label="Nom"
                            name="name"
                            onChange={(e) => setData({ ...data, name: e.target.value })}
                        /> */}
                        <Controls.Input
                            label="Pourcentage"
                            name="percentage"
                            type="number"
                            onChange={(e) => setData({ ...data, percentage: e.target.value })}
                        />
                    </Container>
                    <Container sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Controls.Button onClick={handleSaveData} text="Ajouter" size={'small'} />
                    </Container>
                </Grid>
            </Popup>
        </>
    )
}

export default AddTransect
